module.exports = __webpack_public_path__ + "img/nodata.bbb4a6c0.jpg";